// Register.js (Constants)
export const FORM_REGISTER = {
  name: "",
  email: "",
  password: "",
  confirmPassword: "",
  phone: "",
  role: "cliente",

  // 👇 NUEVO
  address: "",
  lat: "",
  lng: "",
};